import React, {Fragment} from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';

const borderColor = '#90e5fc'
const styles = StyleSheet.create({
    row: {
        flexDirection: 'row',
        borderBottomColor: '#bff0fd',
        borderBottomWidth: 1,
        alignItems: 'center',
        height: 25,
        fontStyle: 'bold',
        color: 'white'
    },
    description: {
        width: '35%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
        paddingLeft: 8,
        fontSize: 8
    },
    qty: {
        width: '10%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
        textAlign: 'right',
        paddingRight: 5
    },
    caseid: {
      width: '25%',
      borderRightColor: borderColor,
      borderRightWidth: 1,
      textAlign: 'left',
      paddingLeft: 5,
    },

    poNumber: {
        width: '30%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
        textAlign: 'right',
        paddingRight: 4,
    },
    qty: {
        width: '10%',
        textAlign: 'right',
        paddingRight: 4,
    },
  });

const PackageBlankSpace = ({rowsCount}) => {
    const blankRows = Array(rowsCount).fill(0)
    const rows = blankRows.map( (x, i) =>
        <View style={styles.row} key={`BR${i}`}>
          <Text style={styles.caseid}>-</Text>
          <Text style={styles.description}>-&nbsp;{'\n'}-</Text>
          <Text style={styles.poNumber}>-</Text>
          <Text style={styles.qty}>-</Text>
        </View>
    )
    return (<Fragment>{rows}</Fragment> )
};

export default PackageBlankSpace;
